export class ConfigConstants {
  static rounds: string = 'Rounds';
  static sharedResources: string = 'SharedResources';

  static resourceName: string = 'Name';
  static packageName: string = 'WebPackage';
  static sceneName: string = 'MobileWebScene';
  static roundType: string = 'Type';
  static components: string = 'Components';
  static serverIndex: string = 'ServerIndex';
  static nextRoundMap: string = 'NextRoundMap';
  static executeSection: string = 'Execute';

  static componentType: string = 'Type';
  static componentName: string = 'Name';
  static sendValue: string = 'SendValue';
  static selectAction: string = 'SelectAction';
  static disableTouchTrigger: string = 'DisableTouchTrigger';
  static buttonsServerIndex: string = 'ServerIndex';
  static template: string = 'Template';
  static indexesTemplate: string = 'IndexesTemplate';
  static templateFormat: string = 'Format';
  static templateCount: string = 'Count';
  static randomGeneratorType: string = 'GeneratorType';
  static randomGeneratorMode: string = 'GeneratorMode';
  static condition: string = 'Condition';
  static conditionProperty: string = 'Property';
  static conditionValue: string = 'Value';
  static conditionOperation: string = 'Operation';
  static historyMessageProperty: string = 'HistoryMessageProperty';

  static tutorialDelay: string = 'Delay';
  static tutorialStartExecute: string = 'StartExecute';
  static tutorialStopExecute: string = 'StopExecute';

  static elementId: string = 'ElementId';
  static stateId: string = 'State';
  static conditionNotInState: string = 'ConditionNotInState';
  static propertyValue: string = 'Value';
  static valueFormat: string = 'Format';
  static endValueFormat: string = 'EndFormat';
  static property: string = 'Property';
  static targetStateId: string = 'TargetState';
  static targetEvent: string = 'TargetEvent';
  static listenerId: string = 'ListenerId';
  static messageType: string = 'MessageType';
  static executeData: string = 'ExecuteData';
  static duration: string = 'Duration';
  static parentId: string = 'ParentId';
  static nodeOperation: string = 'NodeOperation';
  static destinationElementId: string = 'DestinationElementId';

  static propertyStartValue: string = 'StartValue';
  static propertyEndValue: string = 'EndValue';
  static executionType: string = 'ExecutionType';
  static propertyDurationMultiplierValue: string = 'DurationMultiplierValue';

  static stepDuration: string = 'StepDuration';

  static targetGesture: string = 'TargetGesture';

  static variableName: string = 'Variable';
  static operationName: string = 'Operation';
  static operationSubtract: string = 'Sub';
  static operationAdd: string = 'Add';
  static operationMultiply: string = 'Mul';
  static operationDivision: string = 'Div';

  static operationAssign: string = 'Assign';
  static operationValue: string = 'Value';

  static tutorialName: string = 'TutorialName';
  static tutorialState: string = 'TutorialState';
  static tutorialStart: string = 'Start';
  static tutorialStop: string = 'Stop';
  static tutorialRestart: string = 'Restart';

  static executeSend: string = 'ExecuteSend';
  static executeSendSelectedIndex: string = 'ExecuteSendSelectedIndex';
  static executeSendSelectedValue: string = 'ExecuteSendSelectedValue';

  static randomExecutorComponentName: string = 'RandomName';
  static randomExecutorElementsCount: string = 'RandomCount';

  static targetComponentName: string = 'ComponentName';
  static componentMethod: string = 'ComponentMethod';

  static randomNextCount: string = 'Count';

  static randomNextMethod: string = 'Next';
  static buttonReinit: string = 'Reinit';
  static buttonUpdate: string = 'Update';
}
